<template lang="pug">
  ul.side-nav
    li.side-nav__item(
    v-for="link in sideNavData"
    )
      router-link.side-nav__link(
      :to="link.path"
      :active-class="'side-nav__link_active'"
      ) {{ link.text }}
</template>

<script>
export default {
  name: "side-nav",
  props: ["sideNavData"],
};
</script>
